import {ComponentFactory} from "oca-lib-web";
import Styles from "../style/Styles";

export default class VisualUtil {

    public static getHeaderDisplay(header:string, items?:any):any {
        let cf = new ComponentFactory(Styles.default);
        return cf.renderBoxProps({marginTop:'20px', marginLeft:'20px', marginRight:'20px', marginBottom:'20px'},
            cf.renderHeader(header, items));
    }

    public static renderActionBar(left:any, right?:any) {
        let cf = new ComponentFactory(Styles.default);
        return cf.renderBoxProps({marginLeft:'20px', marginRight:'20px', marginTop:'20px', marginBottom:'20px'}, cf.renderRightLeftLayout(left,right));
    }
}